import React from 'react';
import { Helix2000Character, CharacterClass } from '../../../../shared/CharacterTypes';

interface ClassToolsTabProps {
    player: Helix2000Character;
    onAction: (action: string, data?: any) => void;
}

export const ClassToolsTab: React.FC<ClassToolsTabProps> = ({ player, onAction }) => {
  const buttonStyle: React.CSSProperties = {
    display: 'block',
    width: '100%',
    padding: '10px 12px',
    marginBottom: '8px',
    background: 'rgba(255, 255, 255, 0.05)',
    border: '1px solid rgba(255, 255, 255, 0.1)',
    borderRadius: '4px',
    color: '#ecf0f1',
    cursor: 'pointer',
    textAlign: 'left',
    fontSize: '13px',
    transition: 'all 0.2s'
  };

  const headerStyle: React.CSSProperties = {
    fontSize: '12px',
    textTransform: 'uppercase',
    color: '#888',
    marginBottom: '10px',
    marginTop: '10px',
    fontWeight: 'bold'
  };

  const classes = [
    { id: 'WARRIOR', name: 'Warrior', icon: '⚔️', color: '#e74c3c' },
    { id: 'MAGICIAN', name: 'Magician', icon: '🪄', color: '#3498db' },
    { id: 'ARCHER', name: 'Archer', icon: '🏹', color: '#2ecc71' },
    { id: 'ROGUE', name: 'Rogue', icon: '🥷', color: '#9b59b6' }
  ];

  return (
    <>
      <div style={headerStyle}>Switch Class</div>
      <p style={{ fontSize: '11px', color: '#666', marginBottom: '15px' }}>
        Resets character with new class defaults.
      </p>

      {classes.map(cls => (
        <button
          key={cls.id}
          style={{
            ...buttonStyle,
            borderLeft: player.class === (CharacterClass as any)[cls.id] ? `4px solid ${cls.color}` : buttonStyle.border
          }}
          onClick={() => onAction('set_class', cls.id.toLowerCase())}
        >
          {cls.icon} {cls.name}
        </button>
      ))}

      <div style={{ ...headerStyle, marginTop: '20px' }}>Current Status</div>
      <div style={{ background: 'rgba(0,0,0,0.2)', padding: '10px', borderRadius: '4px', fontSize: '12px' }}>
        <div style={{ color: '#aaa', marginBottom: '4px' }}>Class: <span style={{ color: '#fff' }}>{player.class}</span></div>
        <div style={{ color: '#aaa' }}>Job: <span style={{ color: '#fff' }}>{player.job || 'basic'}</span></div>
      </div>
    </>
  );
};
